import React from 'react'

export const ProgramRequestOfferDescription = (): JSX.Element => (
  <div className="md:text-[0.9vw] text-[#333333]">
    プログラムの詳細をよくお読みの上、リクエストしてください。
  </div>
)
